import { render } from "./TopSellersBlock.vue?vue&type=template&id=10ae5e0f"
import script from "./TopSellersBlock.vue?vue&type=script&lang=js"
export * from "./TopSellersBlock.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TopSellersBlock.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_8fd35eee%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Froadmap%2FTopSellersBlock.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__